const ChartIcon = ({ className, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.10866 1.66699H13.8912C16.7253 1.66699 18.3253 3.27449 18.3337 6.10866V13.892C18.3337 16.7253 16.7253 18.3337 13.8912 18.3337H6.10866C3.27449 18.3337 1.66699 16.7253 1.66699 13.892V6.10866C1.66699 3.27449 3.27449 1.66699 6.10866 1.66699ZM10.0412 14.8837C10.4004 14.8837 10.6995 14.617 10.7329 14.2587V5.76699C10.7662 5.50866 10.642 5.24949 10.417 5.10866C10.1829 4.96699 9.89955 4.96699 9.67538 5.10866C9.44955 5.24949 9.32538 5.50866 9.34955 5.76699V14.2587C9.39205 14.617 9.69121 14.8837 10.0412 14.8837ZM13.8754 14.8837C14.2254 14.8837 14.5245 14.617 14.567 14.2587V11.5253C14.5912 11.2578 14.467 11.0087 14.2412 10.867C14.017 10.7253 13.7337 10.7253 13.5004 10.867C13.2745 11.0087 13.1504 11.2578 13.1837 11.5253V14.2587C13.217 14.617 13.5162 14.8837 13.8754 14.8837ZM6.84952 14.2587C6.81618 14.617 6.51702 14.8837 6.15785 14.8837C5.79952 14.8837 5.49952 14.617 5.46702 14.2587V8.50033C5.44202 8.24116 5.56618 7.98366 5.79202 7.84199C6.01618 7.70033 6.30035 7.70033 6.52535 7.84199C6.74952 7.98366 6.87535 8.24116 6.84952 8.50033V14.2587Z"
        fill={fill || "#888888"}
      />
    </svg>
  );
};

export default ChartIcon;
